import * as React from "react";
import {cx} from "emotion";

import "./summary.scss";

import {cs} from "@Common/react/chain-services";
import {InformationBadge} from "@Common/ui-components/heavy/common/design2/information-badge/information-badge";

export const Summary = ({sections}) => cs(
    () => (
        <div className="summary summary-3on">
            {sections.map((section, i) => (
                <div className="section" key={i}>
                    {section.lines.map((line, lineIndex) => (
                        <div className={cx("line", {big: line.big})} key={lineIndex}>
                            <div className="label">
                                {line.label}
                                {line.description &&
                                    (<span style={{marginLeft: "5px"}}>
                                        {InformationBadge({
                                            getTooltip: () => line.description,
                                            xdQaName: line.label,
                                        })}
                                    </span>)
                                }
                            </div>
                            <div className="value">
                                ${line.value.toFixed(2)}
                            </div>
                        </div>
                    ))}
                </div>
            ))}
        </div>
    ),
);
